import './style.css';
import ArrowRight from '../../img/ui/ui-arrow-top-right.svg';

const Button = ({ link, buttonText, target = '_self', icon = ArrowRight, ariaLabel = '', title = '' }) => {
  return (
    <a
      href={link}
      target={target}
      rel={target === '_blank' ? 'noreferrer noopener' : undefined}
      className="button"
      aria-label={ariaLabel || buttonText}
      title={title || buttonText}
    >
      {buttonText}
      {icon && <img src={icon} alt="icon" />}
    </a>
  );
};

export default Button;
